export default __webpack_public_path__ + "static/media/backspace.1b55d704.svg";